import {BottomTriangle, DragHandle, DragHandleBar, TopTriangle, VerticalLines} from './ChatbotStyles'
import PropTypes from 'prop-types'

const DragBar = ({id = 'chat-window-drag-bar', ...props}) => {
  return (
    <DragHandleBar id={id} data-testid={id} tabIndex={0} {...props} aria-label='Drag Bar'>
      <DragHandle>
        <TopTriangle />
        <VerticalLines />
        <BottomTriangle />
      </DragHandle>
    </DragHandleBar>
  )
}

export default DragBar

DragBar.propTypes = {
  id: PropTypes.string
}
